import React, { useEffect, useRef, useState } from "react";
import { Sun, Moon, Monitor, Check } from "lucide-react";
import { useTheme } from "../../../../context/ThemeContext";

const OPTIONS = [
  { value: "system", label: "System", icon: Monitor },
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
];

const ThemeToggle = () => {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open]);

  const ActiveIcon =
    OPTIONS.find((option) => option.value === theme)?.icon ?? Monitor;

  return (
    <div className="theme-toggle" ref={containerRef}>
      <button
        type="button"
        className="theme-toggle-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`Theme: ${theme} (currently ${resolvedTheme})`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <ActiveIcon />
      </button>

      {open && (
        <div className="theme-toggle-menu" role="menu">
          {OPTIONS.map(({ value, label, icon: Icon }) => (
            <button
              key={value}
              type="button"
              role="menuitemradio"
              aria-checked={theme === value}
              className={theme === value ? "active" : ""}
              onClick={() => {
                setTheme(value);
                setOpen(false);
              }}
            >
              <Icon />
              <span>{label}</span>
              {theme === value && <Check className="theme-toggle-check" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;
